// "CLASS:user" tells the frontpage (class.youwdin.com) who is signed in.
// The member area lives on a subdomain (member.class.youwdin.com), so the
// cookie must be scoped to the frontpage's host or the frontpage can't read
// it. Locally both apps are on localhost (cookies ignore ports), so no
// domain is needed there.
const NAME = "CLASS:user";
// Pre-rename cookie name; only ever cleared or migrated, never written.
const LEGACY_NAME = "BWAMICRO:user";

function cookieDomain() {
  try {
    const front = new URL(process.env.REACT_APP_FRONTPAGE_URL).hostname;
    const here = window.location.hostname;
    return here !== front && here.endsWith(`.${front}`) ? `; domain=${front}` : "";
  } catch (e) {
    return "";
  }
}

function expireCookie(name) {
  const past = "Thu, 01 Jan 1970 00:00:00 GMT";
  document.cookie = `${name}=; expires=${past}; path=/${cookieDomain()}`;
  // Also drop any host-only copy (set before the domain fix).
  document.cookie = `${name}=; expires=${past}; path=/`;
}

function readCookie(name) {
  const prefix = `${name}=`;
  const found = document.cookie
    .split("; ")
    .find((part) => part.startsWith(prefix));
  return found ? found.slice(prefix.length) : null;
}

export function setUserCookie(user) {
  const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
  document.cookie = `${NAME}=${JSON.stringify(user)}; expires=${expires.toUTCString()}; path=/${cookieDomain()}`;
  expireCookie(LEGACY_NAME);
}

export function clearUserCookie() {
  expireCookie(NAME);
  expireCookie(LEGACY_NAME);
}

// One-time move of a pre-rename login cookie to the new name so the
// frontpage keeps seeing the signed-in user.
export function migrateLegacyUserCookie() {
  try {
    const legacy = readCookie(LEGACY_NAME);
    if (legacy === null) return;
    if (readCookie(NAME) === null && legacy !== "") {
      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
      document.cookie = `${NAME}=${legacy}; expires=${expires.toUTCString()}; path=/${cookieDomain()}`;
    }
    expireCookie(LEGACY_NAME);
  } catch (e) {
    // Ignore: cookies unavailable.
  }
}
